module.exports = __webpack_public_path__ + "media/src/images/user/default_profile_photo-fc05f57780fd914d69fe864509fde361.png";